/* ステータスカードのモーダル：リンク以外はどこを押しても閉じる */
(function () {
  'use strict';
  if (window.__mxModalClose) return;
  window.__mxModalClose = true;

  function close(modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var modal = t.closest('.mx-modal');
    if (!modal || modal.hidden) return;
    /* 「ショップへ行く」ボタンだけは除外 */
    if (t.closest('.mx-modal__cta')) return;
    close(modal);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.mx-modal').forEach(close);
  });
})();
